import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomerHistoryReport extends Layout {
    checkboxPageBreak: Checkbox;
    excludabletextboxCategory: ExcludableTextbox;
    excludabletextboxCustomers: ExcludableTextbox;
    excludabletextboxOpUsers: ExcludableTextbox;
    excludabletextboxSalespersons: ExcludableTextbox;
    sourceCustomerHistoryReport: DataSource;
    switchReportType: Switch;
    switchRollUp: Switch;
    textboxFirstYearComparison: Textbox;
    textboxGroupBy: Textbox;
    textboxSecondYearComparison: Textbox;
}
